import React, { Component } from 'react';
import { vaccineGroupService } from '../../../_services/vaccine-group.service';
import { alertActions } from '../../../_actions/alert.actions';

const CURRENT_STEP = 'SELECT_GROUPS';

class SelectGroups extends Component {
  constructor(props) {
    super(props);

    this.state = {
      invalid: '',
      groups: [{}],
      groupOptions: [],
      totalGroupsToSchedule: 0,
    }
  }

  componentDidMount() {
    vaccineGroupService.getAll()
      .then(groups => {
        this.setState({ groupOptions: groups });
      })
      .catch(() => {
        this.props.dispatch(alertActions.error('Could not load vaccine groups. Please try again.'));
      });
  }

  handleValidate = () => {
    const { totalToSchedule } = this.props.data;
    const { groups, totalGroupsToSchedule } = this.state;
    const errors = {};

    if (groups.length === 0) {
      errors.groups = 'Please add a group.';
    } else if (groups.every((group) => { return (group.groupId !== '' && group.count > 0) }) === false) {
      errors.groups = 'Please select a group and/or enter a count to schedule.';
    }

    if (totalToSchedule < totalGroupsToSchedule.count) {
      errors.groups = 'Please adjust groups to schedule.';
    }

    this.setState({ invalid: errors });

    if (!errors.groups) {
      this.props.handleData({ groups, totalGroupsToSchedule });
    }
  }

  handleAddGroup = () => {
    const errors = {};
    const { groups } = this.state;

    if (groups.every((group) => { return (group.groupId !== '' && group.count > 0) }) === false) {
      errors.groups = 'Please select a group and/or enter a count to schedule.';
    }
    else {
      const newGroup = [...groups];
      newGroup.push({});
      this.setState({ groups: newGroup });
    }
    this.setState({ invalid: errors });
  }

  handleRemoveGroup = (position) => {
    const newGroup = [...this.state.groups];
    newGroup.splice(position, 1);

    if (newGroup.length > 0) {
      this.setState({
        totalGroupsToSchedule: newGroup.reduce((acc, curVal) => {
          return { count: acc.count + curVal.count };
        })
      })
    } else {
      this.setState({ totalGroupsToSchedule: { count: 0 } })
    }
    this.setState({ groups: newGroup });
  }

  handleGroupChange = (index, value) => {
    const newGroup = [...this.state.groups];

    if (value) {
      const group = { ...newGroup[index] };

      group.name = (this.state.groupOptions
        .find(group => group.groupId === parseInt(value))).name;

      group.groupId = value;
      newGroup[index] = group;

    } else {
      newGroup[index] = {};
    }
    this.setState({ invalid: {}, groups: newGroup });

  }

  handleCountChange = (index, count) => {
    const group = { ...this.state.groups[index] };
    const newGroup = this.state.groups;

    group.count = count;
    newGroup[index] = group;

    this.setState({
      invalid: {},
      groups: newGroup,
      totalGroupsToSchedule: newGroup.reduce((acc, curVal) => {
        return { count: acc.count + curVal.count };
      }),
    })
  }

  render() {
    const {
      invalid,
      groups,
      groupOptions,
      totalGroupsToSchedule,
    } = this.state;

    if (this.props.currentStep !== CURRENT_STEP) {
      return null;
    }

    return <div className="card axs-shadow">
      <div className="card-body">
        <h3>Mass Schedule <small>Select Groups</small></h3>

        <hr />

        <div className="row">
          <div className="col-12">
            <div className="alert alert-primary" role="alert">
              Select groups that you would like to schedule patients from.
            </div>

            <form className="needs-validation">
              <div className="row">
                <div className="col-8">
                  {groups.length > 0 ? groups.map((group, groupIndex) => {
                    return <div className="form-row" key={groupIndex}>
                      <div className="form-group col">
                        <label>Groups</label>

                        <select onChange={e => { this.handleGroupChange(groupIndex, e.target.value) }} value={group.groupId} className="form-control">
                          <option />
                          {groupOptions.map((groupOption, optionIndex) => {
                            return <option key={optionIndex} value={groupOption.groupId}>{`${groupOption.name} (${groupOption.waitlist} waitlist)`}</option>
                          })}
                        </select>
                      </div>
                      <div className="form-group col">
                        <label>To Schedule</label>
                        <div className="input-group">
                          <input disabled={('groupId' in group) === false} onChange={e => { this.handleCountChange(groupIndex, e.target.value ? parseInt(e.target.value) : 0) }} value={group.count} type="number" min="1" className="form-control" />

                          <div className="input-group-append">
                            <button onClick={() => { this.handleRemoveGroup(groupIndex) }} className="btn btn-outline-secondary" type="button">
                              <i className="fa fa-times" aria-hidden="true"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  })
                    :
                    <div className="mt-3 pt-5">&nbsp;</div>
                  }
                </div>
                <div className="col-2 mb-3" style={{ position: "relative" }}>
                  <div style={{ position: "absolute", bottom: 0 }}>
                    <button onClick={() => { this.handleAddGroup() }} className="btn btn-block btn-outline-secondary" type="button">Add Group</button>
                  </div>
                </div>
              </div>

              {invalid.groups && <div className="text-danger mb-3"><small>{invalid.groups}</small></div>}

              {totalGroupsToSchedule.count > 0 && <p>Total to Schedule: {totalGroupsToSchedule.count}</p>}

            </form>
          </div>
        </div>
      </div>
      <div className="card-footer">
        <div className="row">
          <div className="col-sm-4 pr-2">
            <button
              onClick={this.props.backStep}
              type="button" className="btn btn-outline-primary btn-block">Back</button>
          </div>
          <div className="col-sm-4 pl-2">
            <button
              onClick={this.handleValidate}
              type="button" className="btn btn-primary btn-block">Next</button>
          </div>
        </div>
      </div>
    </div >
  }
}

export default SelectGroups;